import { Collapsible } from "./behaviours/Collapsible.js";
import { ResponsiveBehaviour } from "@iunctim/utility-frontend/Resources/Public/Scripts/utilities/ResponsiveBehaviour.js";
import { Bar } from "./behaviours/Bar.js";

/**
 * Class to implement the bar-menu functionality
 * for a single instance; the application is
 * done via the BarMenuManager class
 */
export class BarMenu extends ResponsiveBehaviour {
    private static readonly BREAKPOINT: number = 1024;

    /**
     * Constructor of the BarMenu
     *
     * @param {HTMLElement} menu
     */
    public constructor(menu: HTMLElement) {
        super();

        // Register the collapsible menu
        this.register(0, new Collapsible(menu));

        // Register the bar menu
        this.register(
            BarMenu.BREAKPOINT,
            new Bar(menu, {
                hover: false,
                debounce: {
                    enter: 75,
                    leave: 25,
                },
            }),
        );

        // Watch for viewport changes
        this.watch();
    }
}
